<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple"
            v-preventReClick @click="handleDelete">删除</el-button>
            <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print">
              <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
                打印
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0">打印</el-dropdown-item>
                <el-dropdown-item command="1">预览</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>


        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="付款申请单号" width="170">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="supplierName" label="供应商"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="totalAmount" label="付款金额"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="totalNumber" label="发票张数"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createdUserName" label="创建人"></el-table-column>
        <el-table-column width="170" prop="createdTime" label="创建时间">
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.createdTime))
            }}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="stateName" label="单据状态"></el-table-column>
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center"
          prop="approverNames"></el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions"
              @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
              v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-else-if="
              scope.row.status != 1 &&
              scope.row.status != 2 &&
              tableAcl.indexOf('Edit') != -1
            " type="text" v-preventReClick @click="handleUpdate(scope.row)"
              class="margin-left20 color-blue">编辑</el-button>

            <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.state != 1" type="text" v-preventReClick
              @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>

            <el-button v-if="
              tableAcl.indexOf('Cancel') != -1 &&
              scope.row.status == 2 &&
              scope.row.state == 0
            " type="text" v-preventReClick @click="handleCancel(scope.row)"
              class="margin-left20 color-blue">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetPaymentApplys, RemovePaymentApply, CancelPaymentApply,GetPaymentApplyPrintData,ExportPaymentApplys } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import { PaymentTypeOptions, ApproveStatusOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetPaymentApplys,
      RemoveAction: RemovePaymentApply,
      cancelAction: CancelPaymentApply,
      editPath: "payment-apply-edit",
      PrintAction: GetPaymentApplyPrintData,
      PaymentTypeOptions: PaymentTypeOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      exportAction:ExportPaymentApplys,
      filterOptions: [
        {
          name: "付款单号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "供应商",
          type: "select",
          code: "supplierId",
          filterMethod: this.getSuppliers,
          data: [],
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
        {
          name: "金额范围",
          type: "numberRange",
          startCode: "startAmount",
          endCode: "endAmount",
        },
        {
          name: "单据状态",
          type: "select",
          code: "states",
          data: PaymentTypeOptions,
          multiple: true,
        },
        {
          name: "发票单号",
          type: "input",
          code: "billNo",
        },
        {
          name: "流程状态",
          type: "select",
          code: "statuses",
          multiple: true,
          data: ApproveStatusOptions,
        },
      ],
    };
  },
  methods: {},
  mounted () { },
};
</script>

<style lang="scss" scoped></style>
